module.exports = __webpack_public_path__ + "static/media/upload-ico-white.4e94f842.svg";